import { Wrapper } from "./DropdownItem.styled";

const DropdownItem = ({ children }) => <Wrapper>{children}</Wrapper>;

export default DropdownItem;
